module.exports = __webpack_public_path__ + "c2166dccd0a8eb1c34a30a8a83686a58.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-27.png
// module id = 1471
// module chunks = 0